import { render, staticRenderFns } from "./CatalogSubCategories.vue?vue&type=template&id=0546ff38&"
import script from "./CatalogSubCategories.js?vue&type=script&lang=js&"
export * from "./CatalogSubCategories.js?vue&type=script&lang=js&"
import style0 from "./CatalogSubCategories.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CatalogSubCategories.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fcatalog%2FCatalogSubCategories%2FCatalogSubCategories.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports